import { Pipe, PipeTransform } from '@angular/core';

import { Link } from '../business/link/link';
import { LinkService } from '../services/link.service';

@Pipe({
    name: 'link',
    standalone: true,
})
export class LinkSyncPipe implements PipeTransform {
    public constructor(private _linkSvc: LinkService) {}

    /**
     * The transform function returns a link synchronously based on the provided value and parameters.
     *
     * @param {Link} value - The `value` parameter is of type `Link`.
     *
     * @param [params] - The `params` parameter is an optional parameter of type `Map<string, string>`.
     *
     *  @returns A string is being returned.
     */
    public transform(value: Link, params?: Map<string, string>): string {
        return this._linkSvc.getLinkSync(value, params);
    }
}
